module.exports = __webpack_public_path__ + "img/03-2-3指标整理.18189998.svg";